<template>
  <div class="bpm-warpper">
    <div class="bpm-hd">
      <div class="bpm-title">
        <i class="layui-icon layui-icon-left" @click="bpmBack" />
        <span>编辑流程</span>
      </div>
      <div class="bpm-btn" v-if="curCmp === 'bpm'">
        <button v-if="type === 'edit'" class="layui-btn" @click="copyTemplate">快速新建</button>
        <button class="layui-btn" @click="saveTemplate">保存模板</button>
      </div>
    </div>
    <!-- <div class="bpm-bd" id="bpmBody">
      <div class="bpm-nav">
        <div
          v-for="item in navData"
          :key="item.name"
          class="nav-item"
          :class="{ 'nav-active': curCmp === item.name }"
          @click="handleChange(item.name)"
        >
          <i :class="[item.active ? item.activeIcon : item.icon]"></i>
          <p>{{ item.label }}</p>
        </div>
      </div>
      <div v-if="curCmp === 'bpm'" class="bpm-node">
        <layui-tree
          ref="nodeTree"
          table-name="YW_FLOW_NODE"
          text-field="NODE_NAME"
          id-field="NODE_ID"
          parent-field="NODE_PID"
          value-field="NODE_ID"
          v-model="treeSelected"
          :condition="{}"
          :sort="['NODE_ORDER:ASC']"
          :default-condition="{ 'DELETED:0': 0 }"
          :show-check="true"
          @treecheck="checkTreeNode"
        />
      </div>
      <div class="bpm-content">
        <bpm v-if="curCmp === 'bpm'" :type="type" height="100%" :bpmData="bpmData" />
        <component v-else :is="curCmp"></component>
      </div>
    </div>
    <save-bpm ref="saveBpm" v-if="save" :visible.sync="save" :info="info" :beforeSaveFn="saveBeforeCbFn" /> -->
    <div class="bpm-bd" id="bpmBody">
      <div class="bpm-nav">
        <div
          v-for="item in navData"
          :key="item.name"
          class="nav-item"
          :class="{ 'nav-active': curCmp === item.name }"
          @click="handleChange(item.name)"
        >
          <i :class="[item.active ? item.activeIcon : item.icon]"></i>
          <p>{{ item.label }}</p>
        </div>
      </div>
      <div class="bpm-node" v-if="curCmp === 'bpm'">
        <layui-tree
          ref="nodeTree"
          table-name="YW_FLOW_NODE"
          text-field="NODE_NAME"
          id-field="NODE_ID"
          parent-field="NODE_PID"
          value-field="NODE_ID"
          v-model="treeSelected"
          :condition="{}"
          :sort="['NODE_ORDER:ASC']"
          :default-condition="{ 'DELETED:0': 0 }"
          :show-check="false"
          @treecheck="checkTreeNode"
          @treeDrag="dragTreeNode"
        />
      </div>
      <div class="bpm-content">
        <bpm-visual
          v-if="curCmp === 'bpm'"
          :type="type"
          ref="bpmVisual"
          class="bpm-content"
          style="height: 100%; width: 100%"
          :info="info"
          :handelBpmData="handelBpmData"
        ></bpm-visual>
        <component v-else :is="curCmp"></component>
      </div>
      <save-bpm ref="saveBpm" v-if="save" :visible.sync="save" :info="info" :beforeSaveFn="saveBeforeCbFn" />
    </div>
  </div>
</template>

<script>
import '../../../../static/style/bpm.css'
import bpmDict from './bpmDict'
// import bpm from './bpm'
import saveBpm from './saveBpm.vue'

import BpmVisual from './visual.vue'
/**
 * @typedef {'add'|'edit'|'view'} CmpType 组件类型
 */

export default {
  name: 'Bpm_Editor',
  components: { bpmDict, saveBpm, BpmVisual },
  props: {
    /** @type {CmpType} */
    type: {
      type: String,
      default: 'add',
    },
    info: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      navData: [
        { name: 'bpmDict', label: '节点库', icon: '', activeIcon: '' },
        { name: 'bpm', label: '模板库', icon: '', activeIcon: '' },
      ],
      curCmp: 'bpmDict',
      treeSelected: '',
      bpmData: [],
      save: false,
      /** 是否时快速新建 & 备份数据 */
      isCopy: false,
      useTheTpl: [],
      mapData: {},
    }
  },
  mounted: function () {
    if (this.type === 'edit') {
      let info = this.info
      let tplNode = JSON.parse2JSON(info.tplNode)
      if (tplNode) {
        this.bpmData = tplNode
      }
      this.curCmp = 'bpm'
      this.checkUseTpl()
    }
  },
  methods: {
    checkUseTpl() {
      this.info.bpmId &&
        this.api
          .queryList(
            'YW_SERVICE_ORDER_V1',
            {
              p2: { 'TEMPLATE_ID:0': this.info.bpmId },
              p9: 'SERVICE_ORDER_NUM,WORK_ORDER_NUM,TEMPLATE_ID,TEMPLATE_NODEID',
            },
            'getSerOrderUseTheTpl'
          )
          .then((res) => {
            let rd = res.result || []
            this.useTheTpl = rd
          })
    },
    bpmBack() {
      this.$emit('update:visible', false)
      // this.$bus.$emit('hideBpm')
    },
    handleChange(name) {
      this.curCmp = name
    },
    // 树状图拖拽事件
    dragTreeNode(node) {
      let curNode = { children: node }
      //  编辑模板时, 拖拽树节点判断 是否有工单在使用该流程
      if (this.useTheTpl.length) {
        let str = []
        this.useTheTpl.map((item) => {
          str.push(item.SERVICE_ORDER_NUM)
        })
        this.layer.openConfirm(`服务单【${str.join('、')}】正在使用，不允许修改流程！`, undefined, undefined, {
          targetEl: $('.bpm-bd'),
        })
        return
      }
      node.alallertchainLabel = []
      node.bz = ''
      node.fileId = ''
      node.imgId = ''
      // 拖拽
      this.$refs['bpmVisual'].lf.dnd.startDrag({
        type: 'EngNode_' + 1,
        id: 'cus_' + node.id,
        properties: {
          node: node,
          type: this.type,
          label: node.title,
          tipShow: node.bz || false,
        },
        text: node.title,
      })
    },
    // 处理bpm 数据
    handelBpmData() {
      let bpmLf = this.$refs['bpmVisual'].lf,
        graphdata = bpmLf.getGraphData(),
        edges = graphdata.edges, // 画布所有的连接对象
        bpmNode = graphdata.nodes
      let hash = {}
      let newbpmNode = edges.reduce(function (item, next) {
        hash[next.targetNodeId] ? '' : (hash[next.targetNodeId] = true && item.push(next))
        return item
      }, [])

      if (newbpmNode.length == 0) {
        this.layer.openMsg('请先连接流程节点', { targetEl: $('.bpm-bd') })
      } else {
        let handelData = []
        bpmNode.forEach((item) => {
          newbpmNode.forEach((element) => {
            if (element.targetNodeId == item.id && JSON.stringify(item.properties) != '{}') {
              handelData.push(item.properties)
            }
          })
        })
        /** 备份现有数据 */
        let currentBpmData = {}
        window.treeNodeAddProp(handelData, { childrenProp: 'children' }, (node) => {
          // 保留须保留的信息字段
          currentBpmData[node.id] = { bz: node.bz, fileId: node.fileId, imgId: node.imgId }
          return node
        })

        let data = window.list2tree2(
          handelData,
          { valRootPid: -1, propPid: 'pid', idKey: 'id' },
          (item) => {
            let newNode = {
              id: item.id,
              pid: item._pid,
              label: item.title,
              bz: '',
              fileId: '',
              imgId: '',
            }
            let currentNode = currentBpmData[newNode.id]
            if (currentNode) {
              Object.assign(newNode, currentNode)
            }
            return newNode
          },
          'drag'
        )
        this.bpmData = data
      }
    },
    checkTreeNode(rows, row) {
      if (this.useTheTpl.length) {
        let str = []
        this.useTheTpl.map((item) => {
          str.push(item.SERVICE_ORDER_NUM)
        })
        this.layer.openConfirm(`服务单【${str.join('、')}】正在使用，不允许修改流程！`, undefined, undefined, {
          targetEl: $('.bpm-bd'),
        })

        let curTreeId = this.treeSelected
        this.$nextTick(() => {
          this.treeSelected = curTreeId
        })
        return
      }
      if (!row.checked) {
        // 取消选中
        let flag = false
        row.children.map((item) => {
          if (item.checked) flag = true
        })

        if (flag) {
          let curTreeId = this.treeSelected
          this.$nextTick(() => {
            this.treeSelected = curTreeId
          })
          this.layer.openMsg('请先取消子节点选中', { targetEl: $('.bpm-bd') })
          return
        }
      }

      // 所有选中节点
      let nodeMap = {}
      rows.map((item) => {
        let newItem = {
          id: item.id,
          pid: item._pid,
          label: item.title,
          // active: false,
          // bz: '',
          // fileId: '',
          // children: []
        }
        nodeMap[newItem.id] = newItem
      })
      if (row._pid != -1 && !nodeMap[row._pid]) {
        this.layer.openMsg('请先选择父节点', { targetEl: $('.bpm-bd') })
        let curTreeId = this.treeSelected
        this.$nextTick(() => {
          this.treeSelected = curTreeId
        })
        return
      }

      /** 备份现有数据 */
      let currentBpmData = {}
      window.treeNodeAddProp(this.bpmData, { childrenProp: 'children' }, (node) => {
        // 保留须保留的信息字段
        currentBpmData[node.id] = { bz: node.bz, fileId: node.fileId, imgId: node.imgId }
        return node
      })
      let data = window.list2tree2(rows, { valRootPid: -1, propPid: 'pid', idKey: 'id' }, (item) => {
        let newNode = {
          id: item.id,
          pid: item._pid,
          label: item.title,
          bz: '',
          fileId: '',
          imgId: '',
        }

        let currentNode = currentBpmData[newNode.id]
        if (currentNode) {
          Object.assign(newNode, currentNode)
        }

        return newNode
      })

      this.bpmData = data
    },
    copyTemplate: function () {
      this.save = true

      this.$nextTick(() => {
        // 如果需要清除原模板上的备注文件在这里处理
        let sForm = this.$refs['saveBpm'].config.form
        // this.isCopy = {
        //   TEMPLATE_NAME: sForm.TEMPLATE_NAME,
        //   BZ: sForm.BZ,
        //   TEMPLATE_NODE: sForm.TEMPLATE_NODE
        // }
        this.isCopy = true
        Object.assign(sForm, {
          TEMPLATE_NAME: '',
          BZ: '',
        })
        this.handelBpmData()
      })
    },
    saveTemplate() {
      this.handelBpmData()
      this.save = true
    },

    /** 保存前回调函数，可处理接口传参 */
    saveBeforeCbFn: function (editRow) {
      editRow.TEMPLATE_NODE = this.bpmData
      editRow.DRAGTEMPLATE_NODE = this.$refs['bpmVisual'].lf.getGraphData()
      if (this.type === 'edit') {
        if (this.isCopy) {
          editRow.IS_NEW = true
        } else {
          editRow.IS_NEW = false
          editRow.TEMPLATE_ID = this.info.bpmId
        }
      }
    },
  },
}
</script>

<style lang="postcss">
.bpm-warpper {
  & .layui-table-view {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/newBpm/addBpm.vue